import { DepositType as ApiDepositType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../common';
import { mapBankAccountType } from '../mapBankAccountType';
import { DepositType } from './types';

export const mapDepositType = (apiDeposit: ApiDepositType): DepositType => {
  return {
    id: apiDeposit.id,
    artist: mapLinkableEntityType(apiDeposit.artist),
    project: apiDeposit.project,
    module: apiDeposit.module,
    subjectType: apiDeposit.subjectType,
    dueDate: apiDeposit.dueDate,
    status: apiDeposit.status,
    contractingParty: mapLinkableEntityType(apiDeposit.contractingParty),
    agency: mapLinkableEntityType(apiDeposit.agency),
    bankAccount: mapBankAccountType(apiDeposit.bankAccount),
    depositGross: apiDeposit.depositGross,
    talentGridId: apiDeposit.talentGridId,
    tourId: apiDeposit.tourId,
    festivalId: apiDeposit.festivalId,
  };
};
